import React, { useState, useEffect, useImperativeHandle, forwardRef, Fragment, useRef } from "react";
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Close as CloseIcon } from '@mui/icons-material';
import LowestPriceIcon from '../../../../icons/lowestPrice.svg?react';
import HighestPriceIcon from '../../../../icons/highestPrice.svg?react';
import HighestRatedIcon from '../../../../icons/highestRated.svg?react';
import FastestIcon from '../../../../icons/fastest.svg?react';

import "./QuoterFiltersCondensed.scss";

const FilterItem = (props) => {
  const [value, setValue] = useState(!!props.default ? props.default : "lowestPrice");

  const handleChange = (e) => {
    setValue(e.target.value);
    props.onChange(value);
  };
  useEffect(() => {
    if (props.onChange) {
      props.onChange(value);
    }
  }, [value]);
  return (
    <FormControl component="fieldset">
      {props.fields.map((field, i) => {
        return <Fragment key={`input${i}`}>
          <RadioGroup aria-label={field.radio.label} name={field.radio.label} value={value} onChange={handleChange}>
          {field.radio.map((r, i) => {
            const label = (
              <Fragment>
                <span className="filter-icon">{r.icon}</span>{r.label}
              </Fragment>
            );
            return <FormControlLabel 
                    key={`radio${i}`} 
                    value={r.sortName} 
                    control={<Radio color="primary" />} 
                    label={label} 
                    labelPlacement="start" 
                    checked={r.selected} />
          })}
          </RadioGroup>
        </Fragment>;
      })}
    </FormControl>
  );
};

const QuoterSortCondensed = forwardRef((props, ref) => {
  const sortPopoverRef = useRef(null);
  const [selectedSortName, setSelectedSortName] = useState("Lowest Price");
  const [isFilterShow, setIsFilterShow] = useState(false);
  const [sortState, setSortState] = useState(props.sortObject || {
    lowestPrice: false,
    highestPrice: false,
    bestSellers: false,
    highestRated: false,
    fastest: false,
  });

  const updateSortState = (key) => {
    const obj = { ...sortState };
    resetSort(obj);

    switch (key) {
      case "lowestPrice":
        obj[key] = true;
        setSelectedSortName("Lowest Price");
        break;
      case "highestPrice":
        obj[key] = true;
        setSelectedSortName("Highest Price");
        break;
      case "bestSellers":
        obj[key] = true;
        setSelectedSortName("Best Seller");
        break;
      case "highestRated":
        obj[key] = true;
        setSelectedSortName("Highest Rated");
        break;
      case "fastest":
        obj[key] = true;
        setSelectedSortName("Fastest");
        break;
      default:
        break;
    };

    setSortState(obj);
  };

  useImperativeHandle(ref, () => ({
    updateSortState
  }));

  const resetSort = (obj) => {
    Object.keys(obj).forEach(key => {
      if (obj[key] === true) {
        obj[key] = false;
      }
    });

    setSortState(obj);
  };

  const showFilter = () => {
    setIsFilterShow(!isFilterShow);
  };

  const handleFilterClose = (event) => {
    if (sortPopoverRef.current && !sortPopoverRef.current.contains(event.target)) {
      setIsFilterShow(false);
    }
  };

  useEffect(() => {
      document.addEventListener("mousedown", handleFilterClose);
      return () => {
        document.removeEventListener("mousedown", handleFilterClose);
      };
  }, []);

  useEffect(() => {
    if (props.setIsSortObject) { props.setIsSortObject(sortState); }
  }, [sortState]);

  return (
    <Fragment>
      <div className="filter-control-condensed-wrapper ">
        <div className={`filter-container sort ${props.isAmerico ? "filter-padding-tight" : ""}`}>
          {!props.isAmerico && <Fragment>
            <div className="filter-popover-container">
              <button className={`filter-control primary-color`} disabled={props.isDisabled} onClick={showFilter}>Sort By <span className="sort-title">{selectedSortName}</span></button>
              <div className={`filter-popover ${isFilterShow ? "filter-popover-visible" : ""}`} ref={sortPopoverRef}>
                <div className="header">
                  <h3>Sort By</h3>
                  <button onClick={showFilter}><CloseIcon /></button>
                </div>
                <div className="content">
                <FilterItem fields={[
                  {
                    radio: [
                      {
                        label: 'Lowest Price',
                        sortName: 'lowestPrice',
                        selected: sortState.lowestPrice,
                        icon: <LowestPriceIcon className={sortState.lowestPrice ? "primary-color" : "icon-color"} />,
                      },
                      {
                        label: 'Highest Price',
                        sortName: 'highestPrice',
                        selected: sortState.highestPrice,
                        icon: <HighestPriceIcon className={sortState.highestPrice ? "primary-color" : "icon-color"} />,
                      },
                      {
                        label: 'Highest Rated',
                        sortName: 'highestRated',
                        selected: sortState.highestRated,
                        icon: <HighestRatedIcon className={sortState.highestRated ? "primary-color" : "icon-color"} />,
                      },
                      {
                        label: 'Fastest',
                        sortName: 'fastest',
                        selected: sortState.fastest,
                        icon: <FastestIcon className={sortState.fastest ? "primary-color" : "icon-color"} />,
                      }
                    ]
                  }]} default={props.quoteResultSortDefault} onChange={updateSortState} />
                </div>
              </div>
            </div>
          </Fragment>}
        </div>
      </div>
    </Fragment>
  )
});

export default QuoterSortCondensed;

FilterItem.propTypes = {
  default: PropTypes.string,
  fields: PropTypes.array,
  onChange: PropTypes.func,
};

QuoterSortCondensed.propTypes = {
  isDisabled: PropTypes.bool,
  quoteResultSortDefault: PropTypes.string,
  setIsSortObject: PropTypes.func,
};
